import type { Module } from '@pc/core';
import { lazyWithReload } from '@pc/ui';

const LotsListPage = lazyWithReload(() => import('./pages/LotsListPage'));
const LotDetailPage = lazyWithReload(() => import('./pages/LotDetailPage'));
const LotNewPage = lazyWithReload(() => import('./pages/LotNewPage'));
const LotsDashboardWidget = lazyWithReload(
  () => import('./widgets/LotsDashboardWidget'),
);

/**
 * Lot Management module.
 *
 * Operates on `inventory.product_lots` (228+ rows imported from OfficeHub).
 * Org-scoped (lots have no `store_id`). Routes declare `/new` BEFORE
 * `/:id` so the static path is not consumed by the UUID matcher (see
 * clients module for the same ordering rule).
 *
 * The module id `lot-management` matches `billing.module_prices.module_id`
 * so the host's flag-map gates this module in/out behind the operator's
 * subscription.
 */
export const lotManagementModule: Module = {
  id: 'lot-management',
  name: 'Lots',
  description:
    'Per-batch tracking for received product. Lot numbers, lab testing, COAs, expirations, recalls.',
  basePath: '/lots',
  routes: [
    { path: '/', element: <LotsListPage /> },
    { path: '/new', element: <LotNewPage /> },
    { path: '/:id', element: <LotDetailPage /> },
  ],
  navItems: [{ label: 'Lots', to: '/lots', order: 17 }],
  dashboardWidgets: [
    {
      id: 'lots-summary',
      span: 1,
      order: 35,
      render: LotsDashboardWidget,
    },
  ],
};
